import { useEffect, useState } from 'react';
import { launchConfetti } from '../easterEggs';
import './AnniversaryBanner.css';

// Visible uniquement le 19 mars (ou avec ?anniversaire dans l'URL pour tester).
function isAnniversaire() {
  const now = new Date();
  const test = new URLSearchParams(window.location.search).has('anniversaire');
  return test || (now.getMonth() === 2 && now.getDate() === 19);
}

function AnniversaryBanner() {
  const [visible, setVisible] = useState(isAnniversaire);
  const annees = new Date().getFullYear() - 2016;

  useEffect(() => {
    if (visible) {
      launchConfetti({ count: 70 });
    }
    // Une seule fois à l'ouverture du site.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!visible) {
    return null;
  }

  return (
    <div className="anniversaire-banner" role="status">
      <span>
        Joyeux anniversaire Gabrielle &amp; Hugo 🎉 {annees} ans aujourd'hui&nbsp;!
      </span>
      <button type="button" aria-label="Fermer" onClick={() => setVisible(false)}>
        ×
      </button>
    </div>
  );
}

export default AnniversaryBanner;
